import React, { useState, useEffect, useCallback } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Box,
  Typography,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { generatePodUrl } from '../services/api';

const PODViewer = React.memo(({ open, onClose, podGcsUri }) => {
  const [loading, setLoading] = useState(false);
  const [signedUrl, setSignedUrl] = useState(null);
  const [error, setError] = useState(null);

  const fetchSignedUrl = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await generatePodUrl(podGcsUri);
      setSignedUrl(response.data.signed_url);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to load POD');
    } finally {
      setLoading(false);
    }
  }, [podGcsUri]);

  useEffect(() => {
    if (open && podGcsUri && !signedUrl) {
      fetchSignedUrl();
    }
  }, [open, podGcsUri, signedUrl, fetchSignedUrl]);

  const handleClose = useCallback(() => {
    setSignedUrl(null);
    setError(null);
    onClose();
  }, [onClose]);

  return React.createElement(Dialog, {
    open: open,
    onClose: handleClose,
    maxWidth: 'lg',
    fullWidth: true
  },
    React.createElement(DialogTitle, null,
      React.createElement(Box, {
        sx: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' }
      },
        'Proof of Delivery',
        React.createElement(IconButton, {
          onClick: handleClose,
          size: 'small'
        },
          React.createElement(CloseIcon, null)
        )
      )
    ),
    React.createElement(DialogContent, { dividers: true },
      loading ? React.createElement(Box, {
        sx: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: 400
        }
      },
        React.createElement(CircularProgress, null)
      ) : error ? React.createElement(Box, {
        sx: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: 400
        }
      },
        React.createElement(Typography, { color: 'error' }, error)
      ) : signedUrl ? React.createElement(Box, {
        sx: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: 400
        }
      },
        React.createElement('img', {
          src: signedUrl,
          alt: 'Proof of Delivery',
          style: {
            maxWidth: '100%',
            maxHeight: '600px',
            objectFit: 'contain'
          }
        })
      ) : React.createElement(Typography, null, 'No POD available')
    ),
    React.createElement(DialogActions, null,
      React.createElement(Button, { onClick: handleClose }, 'Close')
    )
  );
});

PODViewer.displayName = 'PODViewer';

export default PODViewer;

